export function exportTradesCSV(trades) {
  const csv = [
    ["Time", "Instrument", "Side", "Qty", "Price"].join(","),
    ...trades.map(t =>
      [
        t.iso_date.slice(11,19),
        t.tradingsymbol,
        t.side,
        t.qty,
        t.price,
      ].join(",")
    )
  ].join("\n");

  const blob = new Blob([csv], { type: "text/csv" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = "tradebook.csv";
  a.click();
}
